var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("accounts-status-alert", {
    attrs: {
      isTestAccount: true,
      title: _vm.$t("title"),
      message: _vm.$t("description"),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }